import React, { useState, useEffect } from "react";
import { Column } from "../../../../../common/columns";
import Pdf from "../../../../../common/pdfView/pdfView";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchMinus, faSearchPlus, faSync } from "@fortawesome/free-solid-svg-icons";
import { cleanJoin } from "../../../../../utils/stringUtil";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import FileViewer from "react-file-viewer";
import { getAccessToken } from "../../../../../common/authorization/AuthorizeService";
import Loader from "../../../../../common/loader/Loader";

function DocumentPreview({ doc }) {
  const { t } = useTranslation();
  const fileExtension = doc.href == null ? "" : doc.href.split(".").pop().split("&")[0];
  const [href, setHref] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  async function fetchDoc() {
    fetch(`${process.env.REACT_APP_GATEWAY_URL}${doc.href}`, {
      method: "GET",
      headers: {
        "Request-Origin": "pisarnica",
        Authorization: "Bearer " + (await getAccessToken()),
      },
      mode: "cors",
      credentials: "include",
    })
      .then((response) => response.blob())
      .then((file) => {
        setHref(window.URL.createObjectURL(file));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    if (isLoading) fetchDoc();
  }, [isLoading]);

  return (
    <Column className="is-centered is-half">
      {isLoading ? (
        <div className={"my-5"}>
          <Loader />
        </div>
      ) : fileExtension === "docx" ? (
        <FileViewer fileType={fileExtension} filePath={href} />
      ) : fileExtension === "pdf" ? (
        <Pdf path={href} />
      ) : (
        <TransformWrapper
          initialScale={0.8}
          maxScale={5}
          minScale={0.5}
          initialPositionX={0}
          initialPositionY={0}
          wheel={{ wheelDisabled: true }}
          doubleClick={{ disabled: true }}
          centerOnInit={true}
        >
          {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
            <>
              <div
                className={cleanJoin(
                  "has-text-centered",
                  "is-flex is-justify-content-center",
                  "my-1"
                )}
              >
                <FontAwesomeIcon
                  className={cleanJoin("has-color-grey", "is-clickable", "mx-4")}
                  icon={faSearchPlus}
                  size="1x"
                  onClick={() => zoomIn()}
                />
                <FontAwesomeIcon
                  className={cleanJoin("has-color-grey", "is-clickable", "mx-4")}
                  icon={faSearchMinus}
                  size="1x"
                  onClick={() => zoomOut()}
                />
                <FontAwesomeIcon
                  className={cleanJoin("has-color-grey", "is-clickable", "mx-4")}
                  icon={faSync}
                  size="1x"
                  onClick={() => resetTransform()}
                />
              </div>

              <div
                className={cleanJoin(
                  "is-flex is-justify-content-center",
                  "box",
                  "is-borderless",
                  "is-radiusless"
                )}
              >
                <TransformComponent
                  contentStyle={{ cursor: "grab", transform: "translate(50%, 50%)" }}
                  wrapperStyle={{ width: "100%", height: "75vh" }}
                >
                  <img src={href} alt={href} />
                </TransformComponent>
              </div>
            </>
          )}
        </TransformWrapper>
      )}
    </Column>
  );
}

export default DocumentPreview;
